import type { TOC } from '@ember/component/template-only';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';

interface SettingsHotelAccessTablesCellsHeaderBenchmarkSignature {
  Args: {
    column: {
      name: string;
      tooltipContent: string;
    };
  };
}

const SettingsHotelAccessTablesCellsHeaderBenchmark = <template>
  <div class="flex items-center justify-start gap-100">
    {{@column.name}}
    <GeneralIconWithTooltip
      @side="top"
      @tooltipContent={{@column.tooltipContent}}
    />
  </div>
</template> satisfies TOC<SettingsHotelAccessTablesCellsHeaderBenchmarkSignature>;

export default SettingsHotelAccessTablesCellsHeaderBenchmark;
